
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Music, Headphones } from 'lucide-react';
import { UserProfile, MatchCompatibility } from '@/types';
import ProgressBar from './ProgressBar';

interface CompatibilityBreakdownProps {
  currentProfile: UserProfile & { 
    matchScore?: MatchCompatibility;
  };
}

const CompatibilityBreakdown: React.FC<CompatibilityBreakdownProps> = ({ currentProfile }) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-lg">Compatibility Breakdown</CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        <ProgressBar 
          label="Genre Match" 
          value={currentProfile.matchScore?.factors.genreOverlap || 0} 
        />
        
        <ProgressBar 
          label="Role Compatibility" 
          value={currentProfile.matchScore?.factors.roleCompatibility || 0} 
        />
        
        {currentProfile.matchScore?.factors.musicalCompatibility && (
          <ProgressBar 
            label="Musical Style" 
            value={Math.round(
              (currentProfile.matchScore.factors.musicalCompatibility.tempoAlignment +
               currentProfile.matchScore.factors.musicalCompatibility.moodAlignment) / 2
            )}
            icon={<Music className="h-3 w-3" />}
            color="bg-orange-500"
          />
        )}
        
        <ProgressBar 
          label="Location" 
          value={currentProfile.matchScore?.factors.locationProximity || 0} 
        />
        
        {currentProfile.matchScore?.factors.musicalCompatibility && (
          <ProgressBar 
            label="Audience Overlap" 
            value={Math.round(currentProfile.matchScore.factors.musicalCompatibility.audienceOverlap)}
            icon={<Headphones className="h-3 w-3" />}
            color="bg-blue-500"
          />
        )}
      </CardContent>
    </Card>
  );
};

export default CompatibilityBreakdown;
